import axios from 'axios'

export const setSchedule = async (id: string, start_date: Date, end_date: Date, column_id: string, factory_id: number, headers: any) => {
  const branchData = {
    start_date: start_date.toISOString(),
    end_date: end_date.toISOString(),
    equipment_id: column_id,
  }
  try {
    await axios.patch(`/v0/records-processes/${id}/set-schedules`, branchData, {
      headers: headers,
      params: { factory_id: factory_id }
    })
  } catch (error) {
    console.log(error)
  }
}
